import PropTypes from "prop-types";

export default function Gauge({ value, max, label, color, size, strokeWidth }) {
  const safeValue = Number.isFinite(value) ? Math.max(0, Math.min(max, value)) : 0;
  const pct = max > 0 ? safeValue / max : 0;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const dash = circumference * pct;

  return (
    <div
      className="relative shrink-0 flex items-center justify-center"
      style={{ width: size, height: size }}
    >
      <svg width={size} height={size} viewBox={`0 0 ${size} ${size}`}>
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke="var(--surface-3)"
          strokeWidth={strokeWidth}
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={`${dash} ${circumference}`}
          transform={`rotate(-90 ${size / 2} ${size / 2})`}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center text-center">
        <div className="text-[22px] font-bold text-ink leading-none">
          {Number.isFinite(value)
            ? value.toLocaleString(undefined, { maximumFractionDigits: 1 })
            : "—"}
          <span className="text-[14px] font-semibold text-ink-3 ml-[2px]">%</span>
        </div>
        {label && <div className="text-[10.5px] font-medium text-ink-3 mt-[3px]">{label}</div>}
      </div>
    </div>
  );
}

Gauge.propTypes = {
  value: PropTypes.number,
  max: PropTypes.number,
  label: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
  strokeWidth: PropTypes.number,
};

Gauge.defaultProps = {
  value: 0,
  max: 100,
  label: null,
  color: "var(--accent)",
  size: 128,
  strokeWidth: 12,
};
